import { useEffect } from "react";
import NavBar from "../Components/NavBar";
import BlogPreview from "../Components/Blog/BlogPreview/BlogPreview";
import "../Components/Blog/BlogPages/BlogPostPage.css";

export default function BlogIndexPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <NavBar variant="blog" />

      <div className="blog-post blog-index">
        <header className="blog-post-hero">
          <div className="blog-post-heroInner">
            <p className="blog-post-meta">
              <span>Kentucky Home Living</span>
              <span className="dot">•</span>
              <span>Blog</span>
            </p>

            <h1 className="blog-post-title">Blog</h1>
            <p className="blog-post-excerpt">
              Home tips, local guides, and Kentucky living—quick reads to help
              you love where you live.
            </p>
          </div>

          <div className="blog-post-heroImageWrap">
            <img
              className="blog-post-heroImage"
              src="/imgs/blog/blog-hero.jpg"
              alt="Kentucky Home Living Blog"
            />
          </div>
        </header>

        <div
          style={{
            maxWidth: 1180,
            margin: "0 auto",
            padding: "26px 16px 60px",
          }}
        >
          <BlogPreview limit={6} />
        </div>
      </div>
    </>
  );
}
